<template>
  <transition-fade :duration="500" appear>
    <header id="header" class="my-8">
      <h1 class="ml-[35px]">
        <span class="header__welcome">Welkom bij</span>
        <span class="header__brand">#TREFWOORD</span>
      </h1>

      <box-generic v-if="activeVolume" id="school-level-selector-wrapper">
        <template #header>
          <template v-if="activeVolume"
            >Jaargang {{ activeVolume.volumeNumber }}</template
          >
          <template v-if="autoSeason"
            >, Nr. {{ autoSeason.issueNumber }}</template
          >
        </template>
        <template #default>
          <ul v-if="!!schoolLevels?.length">
            <li v-for="schoolLevel in schoolLevels" :key="schoolLevel.slug">
              <router-link-button
                :to="{
                  name: 'CalendarSheet',
                  params: {
                    volumeSlug: activeVolume.slug,
                    schoolLevelSlug: schoolLevel.slug,
                    seasonSlug: autoSeason.slug,
                  },
                }"
                >{{ schoolLevel.title }}</router-link-button
              >
            </li>
          </ul>
        </template>
      </box-generic>
    </header>
  </transition-fade>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { onBeforeRouteUpdate } from "vue-router";

import BoxGeneric from "../../components/content/BoxGeneric.vue";
import RouterLinkButton from "../../components/content/RouterLinkButton.vue";
import TransitionFade from "../../components/magic/TransitionFade.vue";

import ensureValidVolume from "../../router/routes/hub/ensure-valid-volume";

export default {
  name: "HubHeader",
  components: {
    BoxGeneric,
    RouterLinkButton,
    TransitionFade,
  },
  async beforeRouteEnter(to, from, next) {
    return /* (await) */ ensureValidVolume(to, next);
  },
  setup() {
    const store = useStore();
    const activeVolume = computed(() => store.getters.activeVolume);
    const autoSeason = computed(() => store.getters.autoSeason);
    const schoolLevels = computed(() => store.state.container?.schoolLevels);
    onBeforeRouteUpdate(async (to, from, next) =>
      /* (await) */ ensureValidVolume(to, next),
    );
    return {
      activeVolume,
      autoSeason,
      schoolLevels,
    };
  },
};
</script>
